module.exports = {
  siteTitle: "Ducky Devine", // <title>
  shortSiteTitle: "Ducky Devine", // <title> ending for posts and pages
  siteDescription:
    "This is a demo site, so there's not really any content here but the template code is nice.",
  siteUrl: "http://gatsby-platform.hollycummins.com", // This used to be duckydevine.com, but that makes lots of dead links
  pathPrefix: "",
  siteImage: "/preview.png",
  siteLanguage: "en",

  /* author */
  authorName: "Ducky Devine",
  authorShortName: "Ducky",
  authorTwitterAccount: "ducky_devine", // TODO remove this which is only used by Seo.js and is duplication

  /* info */
  headerTitle: "Ducky Devine",
  headerSubTitle: "",

  /* manifest.json */
  manifestName: "Ducky Devine",
  manifestShortName: "DuckyBlog", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [
    { name: "twitter", url: "https://twitter.com/ducky_devine", display: "@ducky_devine" },
    { name: "mastodon", url: "https://mastodon.social/ducky_devine", display: "@ducky_devine@mastodon.social" },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/ducky-devine/",
      display: "Ducky Devine"
    },
    { name: "github", url: "https://github.com/ducky-devine", display: "ducky-devine" },
    { name: "medium", url: "https://ducky-devine.medium.com", display: "Ducky Devine" }
  ]
};
